import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { ConnectStripeButton } from "@/components/ConnectStripeButton/ConnectStripeButton";
import { DashboardInfobox } from "@/dashboard-design-system/Infobox";

export const CustomMessagesDisabledBanner: FC = () => {
  const { t } = useTranslate();

  return (
    <DashboardInfobox
      vibe="brand"
      size="small"
      type="alert"
      data-test="automated-communications-custom-messages-disabled-banner"
      customButton={
        <ConnectStripeButton variant="tonal" vibe="brand">
          {t("dashboard", "ticketing.automatedCommunications.customMessagesDisabled.cta")}
        </ConnectStripeButton>
      }
    >
      {t("dashboard", "ticketing.automatedCommunications.customMessagesDisabled.description")}
    </DashboardInfobox>
  );
};
